import { SxProps } from '@mui/material';

export const cardBody: SxProps = {
  overflow: 'auto',
  minHeight: '30rem',
};
